import ArrowBack from '@mui/icons-material/ArrowBackIos';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import placeholder from '../../../../assets/img/skills-outline.svg';
import Thumbnail from '../../../components/ThumbnailComponent';
import TextInput from '../../../components/UI/TextInput';
import TextareaInput from '../../../components/UI/TextareaInput';
import { convertJsonToFormData } from '../../../helpers/helper';
import { POST } from '../../../services/rest.service';

const SkillCreate = () => {
  const [title, setTitle] = useState('');
  const [icon, setIcon] = useState(null);
  const [description, setDescription] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      title: title,
      icon: icon,
      description: description,
    };
    const formData = convertJsonToFormData(payload);
    try {
      await POST('/admin/skill/save', formData);
      navigate('/admin/skills/list');
      toast.success('New Skill Added');
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleFileChange = (e) => setIcon(e.target.files[0]);

  const handleTitleChange = (e) => setTitle(e.target.value);

  const handleDescriptionChange = (e) => setDescription(e.target.value);

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-lg-8 mb-5">
            <div className="card">
              <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">
                  <a href="#!" onClick={() => navigate(-1)}>
                    <ArrowBack />
                  </a>
                  Add New Skill
                </h3>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="user-avatar">
                        <label htmlFor="skill">
                          <Thumbnail
                            file={icon}
                            style={{ width: '150px', height: '150px' }}
                            placeHolderImage={placeholder}
                            className="rounded-circle mx-3 my-2 my-lg-0 img-fluid c-pointer"
                          />
                        </label>
                        <input id={'skill'} type="file" className="d-none" onChange={handleFileChange} />
                      </div>
                    </div>
                    <div className="col-lg-9">
                      <div className="row">
                        <TextInput
                          value={title}
                          label={'Title'}
                          labelClasses={'text-uppercase'}
                          placeholder={'Please enter a skill name'}
                          size={'col col-lg-6'}
                          error={''}
                          name={'title'}
                          id={'title'}
                          onChange={handleTitleChange}
                        />

                        <TextareaInput
                          label={'Description'}
                          labelClasses={'text-uppercase'}
                          placeholder={'Short description'}
                          size={'col-12'}
                          value={description}
                          error={''}
                          onChange={handleDescriptionChange}
                          name={'description'}
                          id={'description'}
                        />

                        {/* <div className="form-group col-12">
                          <label className="form-label text-uppercase">HTML Content</label>
                          <CKEditor
                            className="texteditor"
                            editor={ClassicEditor}
                            data={content}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setContent(data);
                            }}
                          />
                        </div> */}

                        <div className="form-group col-12">
                          <button type="submit" className="btn btn-primary btn-lg">
                            Create
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SkillCreate;
